import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  role: string;
  token: string;

  constructor(private _authService: AuthService, private _router: Router) {
    this.token = this._authService.getToken();
  }

  canActivate() {
    return this._authService.getRole().pipe(
      map(r => {
        this.role = r.result.ROLE;

        if (this.token && (this.role === 'admin' || this.role === 'teacher' || this.role === 'psychologist' || this.role === 'user')) {
          return true;
        } else {
          this._router.navigate(['/']);
          return false;
        }
      }),
      catchError(() => {
        this._router.navigate(['/']);
        return of(false);
      })
    )
  }
}
